export const Reset = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
    >
      <path d="M15 21C13.4087 21 11.8826 20.3679 10.7574 19.2426C9.63214 18.1174 9 16.5913 9 15C9 14 9.25 13.03 9.7 12.2L8.24 10.74C7.42975 12.0131 6.99958 13.4909 7 15C7 17.1217 7.84286 19.1566 9.34315 20.6569C10.8434 22.1571 12.8783 23 15 23V26L19 22L15 18M15 7V4L11 8L15 12V9C16.5913 9 18.1174 9.63214 19.2426 10.7574C20.3679 11.8826 21 13.4087 21 15C21 16 20.75 16.97 20.3 17.8L21.76 19.26C22.5702 17.9869 23.0004 16.5091 23 15C23 12.8783 22.1571 10.8434 20.6569 9.34315C19.1566 7.84285 17.1217 7 15 7Z" />
    </svg>
  );
};
